module.exports = __webpack_public_path__ + "static/media/ux.b7459eaa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/ux.svg
// module id = 202
// module chunks = 0